// extracted by mini-css-extract-plugin
export default {"title":"style_title__+axdp","categoryItem":"style_categoryItem__Gt2W2","imgBlock":"style_imgBlock__Jjx3z","activeCategory":"style_activeCategory__Gcg8j"};